import React from "react";
import { Autocomplete, Chip, TextField, Typography } from "@mui/material";

type FieldValue = string | string[];

interface CustomAutocompleteProps {
  label: string;
  value: FieldValue;
  options: string[];
  onChange: (newValue: FieldValue) => void;
  multiple?: boolean;
  error?: boolean;
  errorMessage?: string;
  removeErrorMessage?: (field: string) => void;
  fieldName?: string; // Name used to remove the error
}

const CustomAutocomplete: React.FC<CustomAutocompleteProps> = ({
  label,
  value,
  options,
  onChange,
  multiple = true,
  error = false,
  errorMessage,
  removeErrorMessage,
  fieldName,
}) => {
  return (
    <>
      <Autocomplete
        sx={{ margin: "1rem 0" }}
        multiple={multiple}
        options={options.filter((option) =>
          multiple ? !(value as string[]).includes(option) : true
        )}
        value={value}
        onChange={(event, newValue) => {
          if (newValue === null) return;
          onChange(newValue);

          if (removeErrorMessage && fieldName) {
            removeErrorMessage(fieldName);
          }
        }}
        freeSolo
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            error={error}
          />
        )}
        renderTags={
          multiple
            ? (value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    label={option}
                    {...getTagProps({ index })}
                    onDelete={() => {
                      const newValue = (value as string[]).filter(
                        (_, i) => i !== index
                      );
                      onChange(newValue);
                      if (removeErrorMessage && fieldName) {
                        removeErrorMessage(fieldName);
                      }
                    }}
                  />
                ))
            : undefined
        }
      />
      {error && errorMessage && (
        <Typography fontSize={"12px"} color="error" marginTop={"3px"}>
          {errorMessage}
        </Typography>
      )}
    </>
  );
};

export default CustomAutocomplete;
